module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAABL0lEQVRIS+3W3StFQRTG4d+LXEopoigUhchHXJ789b4Sd05xSSmlFCLxamqdG3L2zNntLWXfzsfTWrPXmhEtf6rybEuSq+bljvcFEwbsA+/AkaSX3I1/mpcTYQcYA56AQ0nPddAccBTYA8aBFOGBpMdB0UowbWx7BNgFJoDXSO/DIGgWGOgwsANMAm/AsaT7UjQbDHQI2AKm40c6kXRXghaBgaY1G8As8AGcSrrNRYvB3sa214D5dMTAmaSbHHRgMKJdBpYC7Uq6qkJrgYEuAisBXUrq9kP/Fmi7l9IU1EWjKbW9CizE+Z1Luq46vzRenNJo6OvAXONlYTsV/iYw03jh206tbRuYary1tdq8bbd7Pdlu7wL+rSdGe4+onEIunVNc+KXA1/n/YN0Mflv/CbasfR3QH/8CAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/public/ancientBooks/right_icon@2x.png
// module id = uyBM
// module chunks = 1